/* global TradeInValuations */
// FLOW Ia

import React, { Component } from "react"
import PropTypes from "prop-types"
import LeadForm from "./LeadForm"
import StepReplacementCar from "./StepReplacementCar"
import ContentBelowValuation from "./ContentBelowValuation"
import TradeInResult from "./TradeInResult"
import TradeInResultBeta from "./TradeInResultBeta"
import EmailVerificationStep from "./EmailVerificationStep"

import { trackFunction } from "../../website_script/lib/iframeTrackingHelper"

class FlowLeadFormThenValuation extends Component {
  render() {
    const {
      carSummaryHtml,
      emailVerificationRequired,
      emailVerificationTexts,
      leadFormHtml,
      leadInfo,
      leadSent,
      replacementCarChosen,
      replacementCarSearch,
      tradeInResult,
      handleEditReplacementCar,
      onLeadFormFieldValuesCaptured,
      leadFormFieldValues,
      leadFormStrings,
      betaVersion,
      estimationInfo,
      estimationCar,
      sendPicturesSmsProps,
      currency,
    } = this.props

    return (
      <span>
        {!leadSent ? (
          replacementCarSearch.enabled && !replacementCarChosen ? (
            <StepReplacementCar {...replacementCarSearch} />
          ) : (
            <LeadForm
              leadFormHtml={leadFormHtml}
              onEditReplacementCar={handleEditReplacementCar}
              replacementCar={replacementCarSearch.preselectedCarInfo}
              replacementCarSearchAvailable={replacementCarSearch.enabled}
              onFieldValuesCaptured={onLeadFormFieldValuesCaptured}
              fieldValues={leadFormFieldValues}
              trackFunction={trackFunction}
              strings={leadFormStrings}
            />
          )
        ) : emailVerificationRequired ? (
          <React.Fragment>
            <EmailVerificationStep
              emailVerificationTexts={emailVerificationTexts}
              buyerEmail={leadInfo.email}
              currency={currency}
            />
          </React.Fragment>
        ) : (
          <span>
            {betaVersion ? (
              <React.Fragment>
                <TradeInResultBeta
                  {...tradeInResult}
                  estimationInfo={estimationInfo}
                  estimationCar={estimationCar}
                  sendPicturesSmsProps={sendPicturesSmsProps}
                  trackFunction={trackFunction}
                />
              </React.Fragment>
            ) : (
              <React.Fragment>
                <TradeInResult
                  {...tradeInResult}
                  carSummaryHtml={carSummaryHtml}
                  sendPicturesSmsProps={sendPicturesSmsProps}
                  trackFunction={trackFunction}
                />
              </React.Fragment>
            )}

            <ContentBelowValuation
              {...this.props}
              betaVersion={betaVersion}
              displayValuation={this.props.tradeInResult.displayValuation}
              customerDisclaimer={this.props.tradeInResult.pricingExplanation}
              trackFunction={trackFunction}
            />
          </span>
        )}
      </span>
    )
  }
}

FlowLeadFormThenValuation.propTypes = {
  carSummaryHtml: PropTypes.string,
  emailVerificationRequired: PropTypes.bool,
  emailVerificationTexts: PropTypes.object,
  leadFormHtml: PropTypes.string,
  leadInfo: PropTypes.object,
  leadSent: PropTypes.bool,
  replacementCarChosen: PropTypes.bool,
  replacementCarSearch: PropTypes.object,
  tradeInResult: PropTypes.object,
  handleEditReplacementCar: PropTypes.func,
  onLeadFormFieldValuesCaptured: PropTypes.func,
  leadFormFieldValues: PropTypes.array,
  leadFormStrings: PropTypes.object,
  estimationCar: PropTypes.object,
  betaVersion: PropTypes.bool,
  estimationInfo: PropTypes.object,
  sendPicturesSmsProps: PropTypes.object,
  isUsingPricingRules: PropTypes.bool,
  currency: PropTypes.string,
}

export default FlowLeadFormThenValuation
